import { UserDto } from '@act/shared/data-transfer-objects';
import { DateTime } from 'luxon';

const graceDays = 5;

export const canMakeRequest = (time: number, member: UserDto) => {
  const isInOutreach = member?.memberStage?.key === 'outreach';
  if (isInOutreach) return true;

  const now = DateTime.now();
  const requestTime = DateTime.fromMillis(time);

  const interactionIsInSameMonth =
    now.startOf('month').toMillis() === requestTime.startOf('month').toMillis();
  if (interactionIsInSameMonth) return true;

  const isFirstWeekOfMonth =
    now.startOf('month').plus({ days: graceDays }).toMillis() >= now.toMillis();
  if (!isFirstWeekOfMonth) return false;

  const interactionIsWithinLastMonth =
    now.startOf('month').minus({ month: 1 }).toMillis() <
    requestTime.toMillis();

  return interactionIsWithinLastMonth;
};
